import CompOffReportTypes from './CompOffReport.types';

const INITIAL_STATE = {
	compOffReportData: null,
};

const compOffReportReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	switch (action.type) {
		case CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_START:
			return {
				...state,
				compOffReportData: null,
			};
		case CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_SUCCESS:
			return {
				...state,
				compOffReportData: action.payload,
			};
		case CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_FAILURE:
			return {
				...state,
				compOffReportData: { status: 'error', message: action.payload },
			};
		case CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_RESET:
			return {
				...state,
				compOffReportData: null,
			};

		default:
			return state;
	}
};

export default compOffReportReducer;
